<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <div
          v-on="on"
          class="d-flex justify-center align-center icon-container"
          :style="{ width: size + 'px', height: size + 'px' }"
          :class="COLORS_BY_PRIORITY[priority].bg"
        >
          <v-icon :size="size - 4" :color="COLORS_BY_PRIORITY[priority].icon">{{
            icon
          }}</v-icon>
        </div>
      </template>
      {{ priorityTooltip }}
    </v-tooltip>
  </div>
</template>

<script>
const COLORS_BY_PRIORITY = {
  low: {
    bg: 'blue lighten-5',
    icon: 'blue',
  },
  medium: {
    bg: 'amber lighten-5',
    icon: 'amber darken-2',
  },
  high: {
    bg: 'red lighten-5',
    icon: 'red',
  },
}

const ICONS_BY_PRIORITY = {
  low: 'mdi-chevron-double-down',
  medium: 'mdi-equal',
  high: 'mdi-chevron-double-up',
}

export default {
  name: 'PriorityIcon',

  props: {
    size: {
      type: Number,
      required: false,
      default: 20,
    },
    priority: {
      type: String,
      required: true,
      validator: val => ['low', 'medium', 'high'].includes(val),
    },
  },

  data() {
    return {
      COLORS_BY_PRIORITY,
    }
  },

  computed: {
    priorityTooltip() {
      switch (this.priority) {
        case 'low':
          return this.$t('rev.priority.low_priority')
        case 'medium':
          return this.$t('rev.priority.medium_priority')
        case 'high':
          return this.$t('rev.priority.high_priority')
        default:
          return ''
      }
    },
    icon() {
      return ICONS_BY_PRIORITY[this.priority]
    },
  },
}
</script>

<style lang="scss" scoped>
.icon-container {
  border-radius: 50%;
}
</style>
